import {
    APPLICATION_FORM_FIELDS,
    CANADA_COUNTRY,
    COUNTRY,
    DEFAULT_MEDICAL_EXPERT_FEE
} from "../../helpers/variables";
import { checkIfQuestionHasPendingChanges, checkIfQuestionsHasBeenModified, getTriggeredQuestion } from "../../helpers/questions/functions";
import moment from "moment";
import ApplicationQuestion from "./applicationQuestion";
import {HorizontalRule, FormGroup} from 'arag-ui-lib';
import { FORM_GROUP_VARIANTS, INPUT_TYPE } from '../../helpers/formGroupVariants';
import {
    PALE,
    MOMENT_DATE_FORMAT,
    DATE_OF_BIRTH_MN,
    MED_EXPERT_FEES,
    EXTRA_OPPONENTS,
    POLICY_STATUS_MN_DRAFT,
} from '../../helpers/constants';
import QuestionEditActions from "./QuestionEditActions";
import React from "react";

const PlainApplicationForm = (props) => {
    const {
        checkIfQuestionIsEditable,
        mapEditingQuestionOrFieldToEditingSetting,
        openDeleteAnswerModal,
        openHistoryModal,
        Store,
        approvalOptions,
        groupedQuestions,
        openEditQuestionAnswerModal,
        ChangeNewAppField,
        RemoveExtraOpponent,
        UpdateExtraOpponents,
        removeMedicalExpertFeesTableRow,
        updateMedicalExpertFees,
        breachCausationCp,
        OnDrop,
        HandleDateChange,
        HandleFormCompChange,
        HandleSelectChange,
        onClickActionLink,
        requestApplicationAttachment,
        workSourceOptions,
    } = props;

    const getEditActions = (fieldReference) => {
        const fieldNameId = fieldReference.fakeQuestion.id;
        const fieldName = fieldReference.fieldName;
        const question = fieldReference.name;
        const options = fieldReference.options || [];
        const isEditable = checkIfQuestionIsEditable(question, fieldName);
        const hasPendingChanges = checkIfQuestionHasPendingChanges(null, Store.selectedApplication, fieldName);
        const questionConfig = {
            name: fieldReference.name,
            inputType: fieldReference.inputType || INPUT_TYPE.TEXT,
            machineName: fieldReference.machineName || fieldNameId,
            id: fieldNameId,
            isStandard: true,
            options: options,
        };
        let finalQuestionAnswer = '';
        if(questionConfig.machineName === DATE_OF_BIRTH_MN) {
            finalQuestionAnswer = fieldReference.formatValue(Store.selectedApplication[fieldNameId])
        } else {
            finalQuestionAnswer = Store.selectedApplication[fieldNameId];
        }
        
        return (
            <div className="col-sm-3">
                <QuestionEditActions
                    checkIfPlainEditable={isEditable}
                    question={questionConfig}
                    mapEditingQuestionOrFieldToEditingSetting={mapEditingQuestionOrFieldToEditingSetting}
                    approvalOptions={approvalOptions}
                    onClick={() => openEditQuestionAnswerModal({
                        questionAnswerForEdit: questionConfig,
                        questionAnswer: finalQuestionAnswer,
                    })}
                    hasPendingChanges={hasPendingChanges}
                />
            </div>
        );
    };

    const isLabelClickable = (fieldReference) => {
        const isModified = checkIfQuestionsHasBeenModified(null, Store.selectedApplication, fieldReference.fieldName) 
        return isModified ? () => openHistoryModal(fieldReference.fakeQuestion) : undefined;
    };

    const hasInlineElements = (fieldReference) => {
        return checkIfQuestionIsEditable(null, fieldReference.fieldName) 
            || checkIfQuestionHasPendingChanges(null, Store.selectedApplication, fieldReference.fieldName);
    }

    return (
        <form className="form-horizontal">
            <FormGroup
                labelSize={'col-sm-3'}
                inputSize={'col-sm-6'}
                label={APPLICATION_FORM_FIELDS.SOLICITOR_REFERENCE.name}
                variant={FORM_GROUP_VARIANTS.PLAIN}
                inputProps={{
                    id: APPLICATION_FORM_FIELDS.SOLICITOR_REFERENCE.fakeQuestion.id,
                    name: APPLICATION_FORM_FIELDS.SOLICITOR_REFERENCE.fieldName,
                    label: Store.selectedApplication.solicitorReference,
                }}
                onLabelClick={isLabelClickable(APPLICATION_FORM_FIELDS.SOLICITOR_REFERENCE)}
                hasInlineElements={hasInlineElements(APPLICATION_FORM_FIELDS.SOLICITOR_REFERENCE)}
                inlineGroupElements={getEditActions( APPLICATION_FORM_FIELDS.SOLICITOR_REFERENCE )}
                formGroupTestId={'policy-application-SolicitorFileReference'}
            />
            {COUNTRY !== CANADA_COUNTRY
            ?
                <FormGroup
                    labelSize={'col-sm-3'}
                    inputSize={'col-sm-6'}
                    label={APPLICATION_FORM_FIELDS.WORK_SOURCE.name}
                    variant={FORM_GROUP_VARIANTS.PLAIN}
                    inputProps={{
                        id: APPLICATION_FORM_FIELDS.WORK_SOURCE.fakeQuestion.id,
                        name: APPLICATION_FORM_FIELDS.WORK_SOURCE.fieldName,
                        label: Store.workSourceName,
                    }}
                    onLabelClick={isLabelClickable(APPLICATION_FORM_FIELDS.WORK_SOURCE)}
                    hasInlineElements={hasInlineElements(APPLICATION_FORM_FIELDS.WORK_SOURCE)}
                    inlineGroupElements={getEditActions({
                        ...APPLICATION_FORM_FIELDS.WORK_SOURCE,
                        inputType: INPUT_TYPE.DROP_DOWN,
                        options: workSourceOptions
                    })}
                    formGroupTestId={'policy-application-WorkSource'}
                />
            :
                null
            }
            <HorizontalRule variant={PALE} />
            <FormGroup
                labelSize={'col-sm-3'}
                inputSize={'col-sm-6'}
                label={APPLICATION_FORM_FIELDS.CLIENT_NAME.name}
                variant={FORM_GROUP_VARIANTS.PLAIN}
                inputProps={{
                    id: APPLICATION_FORM_FIELDS.CLIENT_NAME.fakeQuestion.id,
                    name: APPLICATION_FORM_FIELDS.CLIENT_NAME.fieldName,
                    label: Store.selectedApplication.clientName,
                }}
                onLabelClick={isLabelClickable(APPLICATION_FORM_FIELDS.CLIENT_NAME)}
                hasInlineElements={hasInlineElements(APPLICATION_FORM_FIELDS.CLIENT_NAME)}
                inlineGroupElements={getEditActions(APPLICATION_FORM_FIELDS.CLIENT_NAME)}
                formGroupTestId={'policy-application-ClientName'}
            />
            <FormGroup
                labelSize={'col-sm-3'}
                inputSize={'col-sm-6'}
                label={APPLICATION_FORM_FIELDS.DATE_OF_BIRTH.name}
                variant={FORM_GROUP_VARIANTS.PLAIN}
                inputProps={{
                    id: APPLICATION_FORM_FIELDS.DATE_OF_BIRTH.fakeQuestion.id,
                    name: APPLICATION_FORM_FIELDS.DATE_OF_BIRTH.fieldName,
                    label: Store.selectedApplication.dateOfBirth ?
                        moment(Store.selectedApplication.dateOfBirth).format(MOMENT_DATE_FORMAT) : '',
                }}
                onLabelClick={isLabelClickable(APPLICATION_FORM_FIELDS.DATE_OF_BIRTH)}
                hasInlineElements={hasInlineElements(APPLICATION_FORM_FIELDS.DATE_OF_BIRTH)}
                inlineGroupElements={getEditActions({
                    ...APPLICATION_FORM_FIELDS.DATE_OF_BIRTH,
                    inputType: INPUT_TYPE.CALENDAR,
                    formatValue: (value) => value ? moment(value).format(MOMENT_DATE_FORMAT) : ''
                })}
                formGroupTestId={'policy-application-DateOfBirth'}
            />
            <FormGroup
                labelSize={'col-sm-3'}
                inputSize={'col-sm-6'}
                label={APPLICATION_FORM_FIELDS.ADDRESS.name}
                variant={FORM_GROUP_VARIANTS.PLAIN}
                inputProps={{
                    id: APPLICATION_FORM_FIELDS.ADDRESS.fakeQuestion.id,
                    name: APPLICATION_FORM_FIELDS.ADDRESS.fieldName,
                    label: Store.selectedApplication.address,
                }}
                onLabelClick={isLabelClickable(APPLICATION_FORM_FIELDS.ADDRESS)}
                hasInlineElements={hasInlineElements(APPLICATION_FORM_FIELDS.ADDRESS)}
                inlineGroupElements={getEditActions(APPLICATION_FORM_FIELDS.ADDRESS)}
                formGroupTestId={'policy-application-Address'}
            />
            <FormGroup
                labelSize={'col-sm-3'}
                inputSize={'col-sm-6'}
                label={APPLICATION_FORM_FIELDS.POST_CODE.name}
                variant={FORM_GROUP_VARIANTS.PLAIN}
                inputProps={{
                    id: APPLICATION_FORM_FIELDS.POST_CODE.fakeQuestion.id,
                    name: APPLICATION_FORM_FIELDS.POST_CODE.fieldName,
                    label: Store.selectedApplication.postCode,
                }}
                onLabelClick={isLabelClickable(APPLICATION_FORM_FIELDS.POST_CODE)}
                hasInlineElements={hasInlineElements(APPLICATION_FORM_FIELDS.POST_CODE)}
                inlineGroupElements={getEditActions(APPLICATION_FORM_FIELDS.POST_CODE)}
                formGroupTestId={'policy-application-PostCode'}
            />
            {Object.keys(groupedQuestions).map((key, index) => (
                <React.Fragment key={key}>
                    <HorizontalRule variant={PALE}/>
                    {groupedQuestions[key].map(question => {
                        if (question.questionDisplaySettings !== null &&
                            !getTriggeredQuestion(Store.formData, Store.questions, Store?.questions?.find(q => q.id === question.id))) {
                            return null;
                        }
                        return (
                            <ApplicationQuestion
                                key={question.id}
                                openDeleteAnswerModal={openDeleteAnswerModal}
                                onAttachmentRequest={(attachment) => {
                                    requestApplicationAttachment({
                                        applicationId: Store.selectedApplication.id,
                                        attachmentId: attachment.id,
                                        relativeUrl: attachment.relativeUrl
                                    });
                                }}
                                attachments={Store.attachmentsForDisplay}
                                approvalOptions={approvalOptions}
                                checkIfQuestionIsEditable={checkIfQuestionIsEditable}
                                mapEditingQuestionOrFieldToEditingSetting={mapEditingQuestionOrFieldToEditingSetting}
                                openEditQuestionAnswerModal={openEditQuestionAnswerModal}
                                application={Store.selectedApplication}
                                openHistoryModal={openHistoryModal}
                                opponentQuestions={Store.opponentQuestions}
                                onOpponentAdd={() => ChangeNewAppField(EXTRA_OPPONENTS, [...Store.extraOpponents, {
                                    name: '',
                                    prospectsOptionId: '',
                                    insuredOptionId: '',
                                    satisfiedOptionId: '',
                                    insurerOptionId: '',
                                    otherInsurerName: ''
                                }])}
                                removeExtraOpponent={RemoveExtraOpponent}
                                extraOpponents={Store.extraOpponents}
                                updateExtraOpponents={UpdateExtraOpponents}
                                removeMedicalExpertFeesTableRow={removeMedicalExpertFeesTableRow}
                                handleMedicalFeesTableRows={() => ChangeNewAppField(MED_EXPERT_FEES, [...Store.medExpertFees, DEFAULT_MEDICAL_EXPERT_FEE])}
                                isPlain={true}
                                medExpertFees={Store.medExpertFees}
                                updateMedicalExpertFees={updateMedicalExpertFees}
                                breachCausationCp={breachCausationCp}
                                fileDisabled={((Object.keys(Store.selectedApplication).length !== 0 && Store.selectedApplication.constructor === Object) && Store.selectedApplication.policyStatusMachineName !== POLICY_STATUS_MN_DRAFT)}
                                onDrop={OnDrop}
                                handleDateChange={HandleDateChange}
                                questions={Store.questions}
                                textAreaRows={8}
                                question={question}
                                formData={Store.formData}
                                handleSelectChange={HandleSelectChange}
                                handleTextInputChange={HandleFormCompChange}
                                onClickActionLink={onClickActionLink}
                                isLabelClickable={checkIfQuestionsHasBeenModified( question.id, Store.selectedApplication )}
                                isEditModalOpen={Store.questionAnswerModalOpen}
                                isApplicationTab={true}
                            />
                        );
                    })}
                </React.Fragment>
            ))}
        </form>
    );
};

export default PlainApplicationForm;